import React, { useState, useEffect } from 'react';
import "../css/Profile.css";
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function UserProfile() {
  const picLink = "https://cdn-icons-png.flaticon.com/128/1177/1177568.png";
  const { userid } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editName, setEditName] = useState("");
  const [editAbout, setEditAbout] = useState("");
  const [editAboutCount, setEditAboutCount] = useState(0);
  const [editUkey, setEditUkey] = useState("");

  const loggedUser = JSON.parse(localStorage.getItem("user") || "null");
  const isSelf = loggedUser && loggedUser._id === userid;

  useEffect(() => {
    fetch(`/user/${userid}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.user) {
          setUser(result.user);
          setEditName(result.user.name || "");
          setEditAbout(result.user.about || "");
          setEditAboutCount((result.user.about || "").length);
        }
      })
      .catch((err) => console.error(err));
  }, [userid]);

  const saveProfile = async () => {
    const cleanUKey = editUkey.trim().toLowerCase();
    if (!cleanUKey) { toast.error('Please enter your UKey to update profile'); return; }
    if (!editName.trim()) { toast.error('Name cannot be empty'); return; }
    if (editName.length > 100) { toast.error('Name cannot exceed 100 characters'); return; }
    if (!editAbout.trim()) { toast.error('About cannot be empty'); return; }
    if (editAbout.length > 1000) { toast.error('About cannot exceed 1000 characters'); return; }

    try {
      const res = await fetch(`/user/${user._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('jwt'),
        },
        body: JSON.stringify({ name: editName.trim(), about: editAbout.trim(), ukey: cleanUKey }),
      });
      const data = await res.json();
      if (data.error) {
        toast.error(data.error);
        return;
      }
      setUser(data.user);
      setEditUkey("");
      setIsEdit(false);
      try {
        const cur = JSON.parse(localStorage.getItem('user') || '{}');
        if (cur && cur._id === data.user._id) {
          localStorage.setItem('user', JSON.stringify({ ...cur, ...data.user }));
        }
      } catch (e) {}
      toast.success('Profile updated successfully');
    } catch (e) {
      console.error(e);
      toast.error('Save failed');
    }
  };

  if (!user) {
    return (
      <div className="profile" style={{ textAlign: 'center', padding: '40px' }}>
        <p>Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="profile">
      <div className="profile-top-nav">
        <button className="profile-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
      </div>

      <div className="profile-frame">
        <div className="profile-pic">
          <img
            src={(user.Photo && !user.Photo.includes('cloudinary')) ? user.Photo : picLink}
            alt="Profile Avatar"
          />
        </div>

        <div className="profile-data">
          <div className="profile-header">
            <h1 style={{ marginTop: "7px" }} className="username">{user.name}</h1>
            {isSelf && (
              <div className="header-actions">
                <button
                  id="editProfileBtn"
                  onClick={() => {
                    setIsEdit(!isEdit);
                    setEditUkey("");
                  }}
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "#494949",
                    color: "white",
                    fontWeight: "bolder",
                    padding: "6px 14px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  {isEdit ? 'Cancel' : 'Edit'}
                </button>
              </div>
            )}
          </div>

          {isEdit ? (
            <div style={{ marginTop: 12 }}>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>UKey (Update Secret Key)</label>
              <input
                className="mainInputs"
                type="text"
                placeholder="Enter UKey to edit profile"
                value={editUkey}
                onChange={(e) => setEditUkey(e.target.value.toLowerCase().replace(/\s+/g, ''))}
                maxLength={100}
                style={{ width: '100%', marginBottom: 12 }}
              />

              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Name</label>
              <input
                className="mainInputs"
                type="text"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
                maxLength={100}
                style={{ width: '100%', marginBottom: 12 }}
              />

              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>About</label>
              <textarea
                id="editAboutTextArea"
                value={editAbout}
                onChange={(e) => {
                  setEditAbout(e.target.value);
                  setEditAboutCount(e.target.value.length);
                }}
                maxLength={1000}
                style={{ minHeight: 140, width: '100%' }}
              />
              <div style={{ textAlign: 'right', fontSize: 12, color: '#666' }}>{editAboutCount}/1000</div>

              <div style={{ marginTop: 14 }}>
                <button
                  id="editProfileSaveBtn"
                  onClick={saveProfile}
                  style={{
                    marginRight: "10px",
                    borderRadius: "10px",
                    backgroundColor: "#9e9ee5",
                    fontWeight: "600",
                    color: "black",
                    fontSize: "15px",
                    padding: "8px 16px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Save
                </button>
                <button
                  id="editProfileCancleBtn"
                  onClick={() => setIsEdit(false)}
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#67a767",
                    fontWeight: "600",
                    color: "black",
                    fontSize: "15px",
                    padding: "8px 16px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: 8 }}>
              {user.phone && (
                <p style={{ margin: "6px 0" }}>
                  <strong style={{ color: "#94a3b8" }}>Phone: </strong>
                  <span style={{ color: "#fff" }}>{user.phone}</span>
                </p>
              )}

              {user?.about && (
                <div style={{ marginTop: 12 }}>
                  <button
                    onClick={() => setShowAboutModal(true)}
                    style={{
                      marginBottom: "10px",
                      padding: '8px 16px',
                      borderRadius: "12px",
                      backgroundColor: "#494949",
                      color: "white",
                      fontWeight: "bolder",
                      border: "none",
                      cursor: "pointer"
                    }}
                  >
                    See About
                  </button>
                </div>
              )}
            </div>
          )}

          {showAboutModal && (
            <div
              style={{
                position: 'fixed',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000
              }}
              onClick={() => setShowAboutModal(false)}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  background: 'var(--surface, #1e293b)',
                  color: 'var(--text, #fff)',
                  padding: 24,
                  borderRadius: 12,
                  maxWidth: '540px',
                  width: '90%',
                  maxHeight: '80%',
                  overflowY: 'auto'
                }}
              >
                <h3 style={{ marginTop: 0 }}>About</h3>
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 12 }}>{user.about}</div>
                <div style={{ textAlign: 'right', marginTop: 16 }}>
                  <button
                    onClick={() => setShowAboutModal(false)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: "12px",
                      color: '#fff',
                      backgroundColor: "#830a0a",
                      border: "none",
                      cursor: "pointer"
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
